// extracted by mini-css-extract-plugin
module.exports = {"pit_box":"pit_box-1Xp9yN1A"};